export default "__VITE_ASSET__BcECgtrI__"